import React from 'react';
import RegistrationHistoryComponent from '../../../Components/AdminComponents/RegistrationHistory';

const RegistrationHistoryScreen = () => {
  return <RegistrationHistoryComponent />;
};

export default RegistrationHistoryScreen;
